import React from 'react';
import { motion } from 'framer-motion';

const brands = [
    { name: 'Riello', logo: 'RIELLO', image: '/images/riello_logo.png' },
    { name: 'AEC', logo: 'AEC', image: '/images/aec_logo_new.png' },
    { name: 'APC', logo: 'APC', image: '/images/apc_logo.png' },
    { name: 'Tecnoware', logo: 'TECNOWARE', image: '/images/tecnoware_logo.png' },
    { name: 'Atlantis', logo: 'ATLANTIS', image: '/images/atlantis_logo.png' },
];

export default function BrandStrip() {
    // Duplicate brands for seamless loop
    const duplicatedBrands = [...brands, ...brands, ...brands, ...brands];

    return (
        <section className="py-6 md:py-12 bg-gray-50 overflow-hidden">


            <div className="relative">
                {/* Gradient overlays */}
                <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-gray-50 to-transparent z-10" />
                <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-gray-50 to-transparent z-10" />

                <motion.div
                    className="flex gap-8 md:gap-16 items-center"
                    animate={{
                        x: [0, -1200],
                    }}
                    transition={{
                        x: {
                            repeat: Infinity,
                            repeatType: "loop",
                            duration: 30,
                            ease: "linear",
                        },
                    }}
                >
                    {duplicatedBrands.map((brand, index) => (
                        <div
                            key={`${brand.name}-${index}`}
                            className="flex-shrink-0 px-4 md:px-8"
                        >
                            {brand.image ? (
                                <img
                                    src={brand.image}
                                    alt={`${brand.name} logo`}
                                    className="h-8 md:h-12 w-auto object-contain opacity-50 hover:opacity-100 transition-opacity duration-300"
                                />
                            ) : (
                                <span className="text-xl md:text-3xl font-bold text-gray-300 tracking-wider hover:text-gray-600 transition-colors duration-300">
                                    {brand.logo}
                                </span>
                            )}
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}